export default {
    FORMS_SETTINGS_MAPPER_READ: 'forms.settings.mapper:read',
    FORMS_SETTINGS_MAPPER_WRITE: 'forms.settings.mapper:write',
    FORMS_SETTINGS_FIELDS_READ: 'forms.settings.fields:read',
    FORMS_SETTINGS_FIELDS_WRITE: 'forms.settings.fields:write',
    FORMS_SETTINGS_GENERAL_READ: 'forms.settings.general:read',
    FORMS_SETTINGS_GENERAL_WRITE: 'forms.settings.general:write',
};
